import { buildHwApiUrl } from "@hunkware-ui/common";

import { HW_API_URL } from "../../configs";
import { fetcher } from "../../libs";

import { AppointmentCreateParams, AppointmentCreateResponse } from "./types";

/**
 * Book the job as the customer (php runs the staff POST as Scorpion).
 *
 * **Transport-only migration** (`docs/migrations/public-website-accounts-appointments/`): the Node route answers the
 * legacy envelope, so `useNode` — the `HunkWare_General_Appointment_Management_Node_Migration` treatment, shared with the staff
 * appointment routes — changes nothing but where the request goes. The Node URL is absolute, so axios ignores this
 * client's `/public/website` baseURL while both interceptors still run, as `createAddress` does.
 */
export const appointmentCreate = ({
  locationId,
  accountId,
  payload,
  token,
  useNode = false,
}: AppointmentCreateParams) =>
  fetcher.post<AppointmentCreateResponse>(
    useNode
      ? buildHwApiUrl(
          HW_API_URL,
          `/api/v1/public/website/locations/${locationId}/accounts/${accountId}/appointments`,
        )
      : `/locations/${locationId}/accounts/${accountId}/appointments`,
    payload,
    {
      params: { token },
    },
  );
